<div class="project-list">
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner></mat-spinner>
  </div>
  <div class="intro">
    <h2 class="mat-display-2">Liste der Demokratiewerkstatt</h2>
  </div>
  <div class="list">
    <div mat-icon-button mat-card-avatar class="create" routerLink="/demokratiewerkstatt/create">
      <mat-icon color="primary">add_circle_outline</mat-icon>
    </div>

    <mat-form-field>
      <input (keyup)="applyFilter($event)" matInput placeholder="Filter">
    </mat-form-field>

    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef> No.</th>
          <td mat-cell
              *matCellDef="let i = index"> {{ this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex * this.paginator.pageSize }}
          </td>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Titel</th>
          <td mat-cell *matCellDef="let project">
            <a routerLink="/demokratiewerkstatt/{{project.id}}">{{ project.title }}</a></td>
        </ng-container>

        <ng-container matColumnDef="content">
          <th mat-header-cell *matHeaderCellDef> Beschreibung</th>
          <td mat-cell *matCellDef="let project">
            <a routerLink="/demokratiewerkstatt/{{project.id}}">{{ project.content }}</a></td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Erstellt am</th>
          <td mat-cell *matCellDef="let project">
            <a routerLink="/demokratiewerkstatt/{{project.id}}">{{ project.created_at | date }}</a></td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Bearbeiten</th>
          <td mat-cell *matCellDef="let project">
            <button mat-icon-button routerLink="/demokratiewerkstatt/{{project.id}}/edit">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef> Löschen</th>
          <td mat-cell *matCellDef="let project">
            <button mat-icon-button (click)="deleteProject(project)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
